import React from 'react';
import { SectionGroup } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  IWithWorksheetInjectedProps,
  WorksheetRecordGrid,
  WorksheetGridFieldSection,
} from 'Components/Worksheets//Core';
import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { useSelector } from 'react-redux';
import { valueOrDefault } from 'Lib/Any';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import deepEquals from 'Lib/Object/deepEquals';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/BsEnIso/gridFieldSets';
import { pipe } from 'Lib/Hooks/Selectors';

let BsEnIsoLiquidLimitTrialsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 4,
      }))
    ),
    deepEquals
  );

  return (
    <SectionGroup heading="Trials">
      <WorksheetGridFieldSection name="Trials">
        <WorksheetRecordGrid
          name={'Trials'}
          orientation={'horizontal'}
          recordProps={{
            width: 130,
            preventRemove: (i) => trialRecordProps[i]?.preventRemove,
            dim: (i) => trialRecordProps[i]?.dim,
            enforceAtLeastOneRecord: true,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Trial Deletion',
              confirmText: 'Are you sure you want to delete the selected trial?',
              confirmButtonText: 'Delete Trial',
            },
          }}
          fieldSet={[
            {
              name: 'Penetrations',
              recordProps: {
                enforceAtLeastOneRecord: false,
                preventRemove: (i) => i < 2,
                preventCreate: (i) => i === 0,
                removeConfirm: {
                  confirm: true,
                  confirmTitle: 'Delete Penetration',
                  confirmText: 'Are you sure you want to delete the penetration reading? Data cannot be recovered.',
                  confirmButtonText: 'Delete',
                },
              },
              fields: [
                {
                  name: 'InitialPenetration',
                  component: <Field input={<NumericInput />} />,
                  label: (i) => `Initial Penetration ${i + 1} (mm)`,
                },
                {
                  name: 'FinalPenetration',
                  component: <Field input={<NumericInput />} />,
                  label: (i) => `Final Penetration ${i + 1} (mm)`,
                },
                {
                  name: 'Penetration',
                  component: <Field input={<TextOutput />} />,
                  label: (i) => `Penetration ${i + 1} (mm)`,
                },
              ],
            },
            {
              name: 'AveragePenetration',
              component: <Field input={<TextOutput />} />,
            },
            ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
            {
              name: 'ExcludedTrial',
              component: <Field input={<Checkbox />} />,
            },
          ]}
        />
      </WorksheetGridFieldSection>
    </SectionGroup>
  );
};

BsEnIsoLiquidLimitTrialsSection = withInjectedProps(BsEnIsoLiquidLimitTrialsSection);

export { BsEnIsoLiquidLimitTrialsSection };
export default BsEnIsoLiquidLimitTrialsSection;
